import { baseRequest } from '@/utils/request'

const request = (url, ...arg) =>  baseRequest(`/biz/c/statistics/${url}`, ...arg)
/**
 * 统计数据接口管理
 *
 */
export default {
	// 获取用户我的足迹，投递，面试，对我感兴趣
	userResume(data) {
		return request('userResume', data, 'get')
	},
	// 获取企业首页收到投递，收藏，浏览记录，面试邀请
	bizcCompanyInfo(data) {
		return request('companyInfo', data, 'get')
	},
}
